"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../colors");
exports.SectionHeader = styled_components_1.default.h2 `
  font-size: 18px;
  font-weight: 300;
  color: ${colors_1.headingTextColor};
  border-bottom: 2px solid ${colors_1.headingTextColor};
  padding-bottom: 5px;
  display: block;
`;
//# sourceMappingURL=section-header.js.map